export const historyStyles = {
  contentWrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', lg: 'row' },
    gap: { xs: '40px', lg: '81px' },
    alignItems: 'stretch',
  },
  leftPanel: {
    flex: { xs: '1', lg: '1' },
    width: { xs: '100%', lg: '50%' },
  },
  rightPanel: {
    flex: { xs: '1', lg: '1' },
    width: { xs: '100%', lg: '50%' },
    display: { xs: 'none', lg: 'block' },
  },
} as const;
